
const contents = "query InformationBarrierSettingsClients($userId: ID!) {\n  user: node(id: $userId) {\n    ... on User {\n      id\n      officeUserId\n      hasInformationBarrierRestrictions\n    }\n  }\n  viewer {\n    shouldShowInformationBarrierPublisherWarning\n  }\n}";
const sha256Hash = "598b1b8a5989efdebe0026ba63b00fb6f3b077ba5343288dc396d5c7743ccb13";
export default { contents: contents, sha256Hash: sha256Hash };
